/**
 * Admin allowlist for /admin/* routes.
 *
 * Reads `VITE_ADMIN_EMAILS` (comma-separated) from build-time env; falls
 * back to the bootstrap admin if the env var is unset. The allowlist is
 * not a secret — emails are visible in the bundle, which is fine since
 * they're authorization claims, not credentials.
 *
 * To add admins in production: set `VITE_ADMIN_EMAILS` in Cloudflare
 * Pages → Settings → Environment variables (Preview AND Production).
 *   VITE_ADMIN_EMAILS=alice@example.com,bob@example.com
 *
 * For real admin enforcement at the API layer (so an attacker can't
 * just hit /api/seo/scan directly), the worker functions need to
 * verify the Supabase JWT and check the email server-side. That is
 * NOT done yet — see README / follow-up work.
 */

const BOOTSTRAP_ADMIN = 'ehsaasradio@gmail.com';
const BOOTSTRAP_BULK_READ = 'syedmubashirhaq@gmail.com';

function parseAdmins(raw: string | undefined): Set<string> {
  if (!raw) return new Set([BOOTSTRAP_ADMIN]);
  const list = raw
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter(Boolean);
  return list.length > 0 ? new Set(list) : new Set([BOOTSTRAP_ADMIN]);
}

const ADMINS = parseAdmins(import.meta.env.VITE_ADMIN_EMAILS as string | undefined);
const BULK_READERS = parseAdmins(
  import.meta.env.VITE_BULK_READ_EMAILS as string | undefined,
);

export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return ADMINS.has(email.toLowerCase());
}

export function canBulkMarkAyahs(email: string | null | undefined): boolean {
  if (!email) return false;
  if (!import.meta.env.VITE_BULK_READ_EMAILS) {
    return email.toLowerCase() === BOOTSTRAP_BULK_READ;
  }
  return BULK_READERS.has(email.toLowerCase());
}
